import { render } from "./ItemsIntro.vue?vue&type=template&id=53e5dfd6&scoped=true"
import script from "./ItemsIntro.vue?vue&type=script&lang=js"
export * from "./ItemsIntro.vue?vue&type=script&lang=js"

import "./ItemsIntro.vue?vue&type=style&index=0&id=53e5dfd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53e5dfd6"

export default script
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator});
